import { css } from 'styled-components';

export default css`
  .chakra-modal__header {
    padding: 1.5rem !important;
    border-bottom: 3px solid ${({ theme }) => theme.colors.light.color} !important;

    h2 {
      margin: 0;
      font-weight: bold !important;
    }
  }
  .chakra-modal__close-btn {
    background: ${({ theme }) => theme.colors.medium.color};
    border-width: 0;

    position: relative;
    margin-left: auto;
    top: 1.3rem !important;

    &:hover {
      background: ${({ theme }) => theme.colors.light.color} !important;
    }

    svg {
      color: ${({ theme }) => theme.colors.title};
    }
  }

  .chakra-modal__content {
    border-radius: 10px !important;
  }

  .chakra-modal__body {
    padding: 0 !important;
  }
`;
